module.exports = __webpack_public_path__ + "img/yjfx-img3.a75348ad.png";